// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Toasts for squares confirmed live -- see VerifiedTileNotifications.js
 *
 * Colours come from the --wsb-* tokens (declared in assets/css/BingoCard.css,
 * re-declared by each theme), so a toast is burnt orange on an ordinary night
 * and deep indigo once the show calls After Dark, without this file knowing
 * about either. Sizes and spacing are fixed here, so a change of look can never
 * move a toast.
 */

.notification-container {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 1000;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
}

.notification-message {
  background-color: var(--wsb-toast-bg); /* Initial color, will be overridden by animation */
  color: var(--wsb-toast-ink);
  padding: 10px 15px;
  margin-top: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px var(--wsb-shadow);
  max-width: 300px;
  word-wrap: break-word;
  transition: all 0.3s ease;
}

.notification-message:hover {
  opacity: 1; /* Full opacity on hover */
  animation: rainbowAnimation 3s linear infinite; /* RGB animation on hover */
  background-color: initial; /* Reset background color to allow animation */
}

@keyframes rainbowAnimation {
  0%   {background-color: red;}
  14%  {background-color: orange;}
  28%  {background-color: yellow;}
  42%  {background-color: green;}
  57%  {background-color: blue;}
  71%  {background-color: indigo;}
  85%  {background-color: violet;}
  100% {background-color: red;}
}

/*
.notification-message:not(:last-child) {
  margin-bottom: 10px;
}*/

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.notification-message.fade-out {
  animation-name: fadeOut;
  animation-duration: 10s; /* Increase duration to 10 seconds */
  animation-fill-mode: forwards;
}

.notification-message.fade-to-partial {
  background-color: var(--wsb-toast-bg-idle); /* the settled, quieter fill */
  opacity: 0.1; /* Reduced opacity */
  transition: opacity 10s ease, background-color 0s; /* Transition for opacity and immediate background change */
  animation: none; /* No animation by default */
}

.notification-message.fade-to-partial:hover {
  opacity: 1; /* Full opacity on hover */
  animation: rainbowAnimation 3s linear infinite; /* RGB animation on hover */
  transition: opacity 1s ease, background-color 1s; /* Transition for opacity and immediate background change */
  background-color: initial; /* Reset background color to allow animation */
}

/* Style for the pin icon */
.pin-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
}

/* "Hide All Notifications". It sits over the page's own photographic backdrop
   rather than over a themed panel, so it stays a plain text control -- but its
   ink is the toasts' ink, so a theme that changes those changes this too. */
.notification-container .toggle-notifications-button {
  color: var(--wsb-toast-ink);
}
`, "",{"version":3,"sources":["webpack://./src/components/notifications/VerifiedTileNotifications.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,qCAAqC,EAAE,mDAAmD;EAC1F,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU,EAAE,0BAA0B;EACtC,8CAA8C,EAAE,2BAA2B;EAC3E,yBAAyB,EAAE,8CAA8C;AAC3E;;AAEA;EACE,MAAM,qBAAqB,CAAC;EAC5B,MAAM,wBAAwB,CAAC;EAC/B,MAAM,wBAAwB,CAAC;EAC/B,MAAM,uBAAuB,CAAC;EAC9B,MAAM,sBAAsB,CAAC;EAC7B,MAAM,wBAAwB,CAAC;EAC/B,MAAM,wBAAwB,CAAC;EAC/B,MAAM,qBAAqB,CAAC;AAC9B;;AAEA;;;EAGE;;AAEF;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,uBAAuB;EACvB,uBAAuB,EAAE,oCAAoC;EAC7D,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C,EAAE,8BAA8B;EAC1E,YAAY,EAAE,oBAAoB;EAClC,iDAAiD,EAAE,2DAA2D;EAC9G,eAAe,EAAE,4BAA4B;AAC/C;;AAEA;EACE,UAAU,EAAE,0BAA0B;EACtC,8CAA8C,EAAE,2BAA2B;EAC3E,gDAAgD,EAAE,2DAA2D;EAC7G,yBAAyB,EAAE,8CAA8C;AAC3E;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;;4EAE4E;AAC5E;EACE,2BAA2B;AAC7B","sourcesContent":["/* Toasts for squares confirmed live -- see VerifiedTileNotifications.js\n *\n * Colours come from the --wsb-* tokens (declared in assets/css/BingoCard.css,\n * re-declared by each theme), so a toast is burnt orange on an ordinary night\n * and deep indigo once the show calls After Dark, without this file knowing\n * about either. Sizes and spacing are fixed here, so a change of look can never\n * move a toast.\n */\n\n.notification-container {\n  position: fixed;\n  bottom: 10px;\n  right: 10px;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: flex-end;\n}\n\n.notification-message {\n  background-color: var(--wsb-toast-bg); /* Initial color, will be overridden by animation */\n  color: var(--wsb-toast-ink);\n  padding: 10px 15px;\n  margin-top: 10px;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px var(--wsb-shadow);\n  max-width: 300px;\n  word-wrap: break-word;\n  transition: all 0.3s ease;\n}\n\n.notification-message:hover {\n  opacity: 1; /* Full opacity on hover */\n  animation: rainbowAnimation 3s linear infinite; /* RGB animation on hover */\n  background-color: initial; /* Reset background color to allow animation */\n}\n\n@keyframes rainbowAnimation {\n  0%   {background-color: red;}\n  14%  {background-color: orange;}\n  28%  {background-color: yellow;}\n  42%  {background-color: green;}\n  57%  {background-color: blue;}\n  71%  {background-color: indigo;}\n  85%  {background-color: violet;}\n  100% {background-color: red;}\n}\n\n/*\n.notification-message:not(:last-child) {\n  margin-bottom: 10px;\n}*/\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.notification-message.fade-out {\n  animation-name: fadeOut;\n  animation-duration: 10s; /* Increase duration to 10 seconds */\n  animation-fill-mode: forwards;\n}\n\n.notification-message.fade-to-partial {\n  background-color: var(--wsb-toast-bg-idle); /* the settled, quieter fill */\n  opacity: 0.1; /* Reduced opacity */\n  transition: opacity 10s ease, background-color 0s; /* Transition for opacity and immediate background change */\n  animation: none; /* No animation by default */\n}\n\n.notification-message.fade-to-partial:hover {\n  opacity: 1; /* Full opacity on hover */\n  animation: rainbowAnimation 3s linear infinite; /* RGB animation on hover */\n  transition: opacity 1s ease, background-color 1s; /* Transition for opacity and immediate background change */\n  background-color: initial; /* Reset background color to allow animation */\n}\n\n/* Style for the pin icon */\n.pin-icon {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  cursor: pointer;\n}\n\n/* \"Hide All Notifications\". It sits over the page's own photographic backdrop\n   rather than over a themed panel, so it stays a plain text control -- but its\n   ink is the toasts' ink, so a theme that changes those changes this too. */\n.notification-container .toggle-notifications-button {\n  color: var(--wsb-toast-ink);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
